import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';

import { TickerSearchDrawer } from './TickerSearchDrawer';
import { TickerComboBox } from './TickerComboBox';

import { type Props as PrimaryListingProps } from './PrimaryListing';
import { type Props as SecondaryListingProps } from './SecondaryListing';

export type Option = PrimaryListingProps | SecondaryListingProps;

interface Props {
  options: Option[];
  onSelect?: (id: string) => void;
  inputValue?: string;
  onInputChange?: (value: string) => void;
  onCancel?: () => void;
  status: 'pending' | 'success' | 'error';
}

export const TickerSearch = ({
  options,
  onSelect,
  inputValue,
  onInputChange,
  onCancel,
  status,
}: Props) => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  return isMobileScreen ? (
    <TickerSearchDrawer
      options={options}
      onSelect={onSelect}
      inputValue={inputValue}
      onInputChange={onInputChange}
      onCancel={onCancel}
      status={status}
    />
  ) : (
    <TickerComboBox
      options={options}
      onSelect={onSelect}
      inputValue={inputValue}
      onInputChange={onInputChange}
      status={status}
    />
  );
};
